export default "__VITE_ASSET__BOEVckg5__"